import { useState } from "react";

import { IVehicle } from "../../models/Vehicle";
import Card from "../shared/Card/Card";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import { SearchPaletteItem } from "../shared/Inputs/SearchPaletteTypes";
import AwaitingInventoryStatusDropdown from "../awaitingInventory/AwaitingInventoryStatusDropdown";
import PartsPriorityDropdown from "../awaitingInventory/PartsPriorityDropdown";
import YardStatusDropdown from "../awaitingInventory/YardStatusDropdown";
import VehicleLocationDropdown from "./VehicleLocationDropdown";
import VehicleComplexityDropdown from "./VehicleComplexityDropdown";
import BulkAddToWorkOrderModal from "../workOrders/BulkAddToWorkOrderModal";

const ActionRow = ({ label, children }: { label: string; children: React.ReactNode }) => (
  <div className="flex flex-col gap-1">
    <p className="text-sm font-medium text-gray-500">{label}</p>
    {children}
  </div>
);

export default function VehicleQuickActions({ vehicle }: { vehicle: IVehicle }) {
  const [workOrderOpen, setWorkOrderOpen] = useState(false);

  const linkedName = `${vehicle.vrm ?? "Unknown VRM"}${vehicle.combinedMake ? ` - ${vehicle.combinedMake}` : ""}${
    vehicle.combinedModel ? ` ${vehicle.combinedModel}` : ""
  }`;

  const linkedItems: SearchPaletteItem[] = [{ id: vehicle.id, name: linkedName, type: "Vehicle" }];

  return (
    <Card title="Quick Actions" bodyClassName="p-4">
      <BulkAddToWorkOrderModal
        open={workOrderOpen}
        onClose={() => setWorkOrderOpen(false)}
        selectedItems={linkedItems}
      />

      <div className="space-y-4">
        <ActionRow label="Parts Status">
          <AwaitingInventoryStatusDropdown vehicle={vehicle} classes="w-full" />
        </ActionRow>
        <ActionRow label="Parts Priority">
          <PartsPriorityDropdown vehicle={vehicle} classes="w-full" />
        </ActionRow>
        <ActionRow label="Yard Location">
          <VehicleLocationDropdown vehicle={vehicle} classes="!mt-0" size="sm" />
        </ActionRow>
        <ActionRow label="Yard Status">
          <YardStatusDropdown vehicle={vehicle} classes="w-full" />
        </ActionRow>
        <ActionRow label="Complexity">
          <VehicleComplexityDropdown vehicle={vehicle} classes="w-full" />
        </ActionRow>

        <ButtonInput
          label="Add to work order"
          isSubmit={false}
          onClick={() => setWorkOrderOpen(true)}
          classes="w-full"
        />
      </div>
    </Card>
  );
}
